<template>
  <div class="modal__content modal__content--top-up-modal modal__content--mobile-scroll pt30 pl30 pr30">
    <button class="modal__close" @click="$bus.$emit('modalClose')">
      <span class="icon-remove"></span>
    </button>

    <app-loader ref="loader"></app-loader>

    <!-- step 0 -->
    <section v-show="paymentSteps === 0">
      <h2 class="text-color-white text-medium text-size-24 text-center pb30 mb0">Enter biling information </h2>
      <div class="flex flex-nowrap flex--justify-space-between">
        <button 
          @click="paymentSteps = 1"
          class="btn--payment text-size-16 text-medium w-50 mr10">
          <i class="icon--bank-card mlauto mrauto mb15"></i>
          <span class="mb0">Credit card or bank transfer</span> 
        </button>
        <button 
          @click="paymentSteps = 1"
          class="btn--payment text-size-16 text-medium w-50 mr10">
          <i class="icon--bitcoin mlauto mrauto mb10"></i>
          <span class="mb0">Crypto payment (BTC)</span>
        </button>
      </div>
    </section>
    <!-- step 0 -->

    <!-- step 1 -->
    <section v-show="paymentSteps === 1">
      <h2 class="text-color-white text-medium text-size-24 text-center pb30 mb0">Select payment method</h2>
      <div class="flex flex-nowrap flex--justify-space-between pb30">
        <button 
          @click="userInformation.customerType = 'COMPANY'"
          class="btn--payment text-size-16 text-medium w-50 mr10"
          :class="{active: userInformation.customerType === 'COMPANY'}">
          <i class="icon--company mlauto mrauto mb10"></i>
          <span>We're a Company</span>
        </button>
        <button 
          @click="userInformation.customerType = 'INDIVIDUAL'"
          class="btn--payment text-size-16 text-medium w-50 ml10"
          :class="{active: userInformation.customerType === 'INDIVIDUAL'}">
          <i class="icon--individual mlauto mrauto mb10"></i>
          <span>I'm an individual</span>
        </button>
      </div>
      <div class="form-group pb30">
        <div class="w-50 pl5 pr10 mb20">
          <label for="name" class="text-white-08 text-medium text-size-12 text-uppercase">First Name</label>
          <input 
            id="name" class="form-control" v-model="userInformation.customerFirstName" name="name" 
            v-validate="'required|min:2'" :class="{'has-error': errors.has('name')}"
            type="text" placeholder="Albert">
        </div>
        <div class="w-50 pl10 pr5 mb20">
          <label for="surname" class="text-white-08 text-medium text-size-12 text-uppercase">Last Name</label>
          <input 
            id="surname" class="form-control" v-model="userInformation.customerLastName"
            v-validate="'required|min:2'" :class="{'has-error': errors.has('surname')}"
            type="text" name="surname" placeholder="Flores">
        </div>
        <div class="w-100 pl5 pr5 mb20" v-if="userInformation.customerType === 'COMPANY'">
          <label for="company" class="text-white-08 text-medium text-size-12 text-uppercase">Company Full Name</label>
          <input class="form-control" v-validate="'required|min:1'" :class="{'has-error': errors.has('company')}"
            type="text" name="company" id="company" v-model="userInformation.customerCompanyName"
            placeholder="Apple">
        </div>
        <div class="w-100 pl5 pr5 mb20">
          <label for="address"  class="text-white-08 text-medium text-size-12 text-uppercase">Street Address</label>
          <input 
            id="address" class="form-control" v-model="userInformation.customerAddress"
            v-validate="'required|min:1'" :class="{'has-error': errors.has('address')}"
            type="text" name="address" placeholder="Street address">
        </div>
        <div class="w-33 pl5 pr5">
          <label for="city" class="text-white-08 text-medium text-size-12 text-uppercase">City</label>
          <input 
            id="city" class="form-control" v-model="userInformation.customerPost"
            v-validate="'required|min:1'" :class="{'has-error': errors.has('city')}"
            type="text" name="city" placeholder="City" >
        </div>
        <div class="w-33 pl5 pr5">
          <label for="country" class="text-white-08 text-medium text-size-12 text-uppercase">Country</label>
          <div class="form-row__select">
            <select 
              id="country" class="form-control" v-model="country" @change="onCountrySelect" 
              v-validate="'required'" :class="{'has-error': errors.has('country')}"
              name="country">
              <option v-for="country in countries" :value="country" :key="country.id">{{country.countryName}}</option>
            </select>
          </div>
        </div>
        <div class="w-33 pl5 pr5">
          <label for="city" class="text-white-08 text-medium text-size-12 text-uppercase">Post code</label>
          <input 
            id="postcode" class="form-control" v-model="userInformation.customerPostCode"
            v-validate="'required|min:1'" :class="{'has-error': errors.has('postcode')}" 
            type="text" name="city" placeholder="" >
        </div>

      </div>
      <div class="flex flex-nowrap flex--justify-space-between">
        <!-- TODO temp disable step 0 and return to step 0 -->
        <button @click="paymentSteps = 0" class="btn--dark-violet text-size-14 text-uppercase text-bold text-space-05 w-50 mr10" :disabled="true">back</button>
        <!-- TODO temp disable step 0 and return to step 0 END -->
        <!-- TODO add disable for continue -->
        <button @click="onPaymentInformationUpdate()" class="btn--green text-size-14 text-uppercase text-bold w-50 ml10">continue</button>
      </div>

    </section>
    <!-- step 1 -->

    <!-- step 2 -->
    <section v-show="paymentSteps === 2" class="">
      <h2 class="text-color-white text-medium text-size-24 text-center ">Pick your membership plan</h2>
      <a
        :class="{'border-bottom-lighter2': currentPlan !== 'none'}" 
        class="link link--green text-apercu text-color-green text-size-18 text-center pb30 flex flex--justify-center" 
        href="https://koncepted.com/pricing" target="_blank">
        View full pricing comparison
      </a>
      
      <!-- select new plan -->
      <template v-if="currentPlan === 'none'">
        <div class="flex">
          <button
            :class="{active: customerPaymentPlanPeriod === 'YEARLY'}"
            class="btn--dark-violet text-size-16 w50"
            @click="customerPaymentPlanPeriod = 'YEARLY'">
            <span>Yearly Billing</span>
            <span class="badge--violet text-size-12 text-space-1 text-uppercase pr10 pl10 pt6 pb5 ml5 mb0">2 months free</span>
          </button>
          <button
            :class="{active: customerPaymentPlanPeriod === 'MONTHLY'}"
            class="btn--dark-violet text-size-16 w50"
            @click="customerPaymentPlanPeriod = 'MONTHLY'">
            Monthly Billing
          </button>
        </div>
        <div v-for="(plan,index) in planList" :key="plan.id" class="flex flex--justify-space-between pt30 pb30" :class="{ 'border-bottom-lighter2': index < 2 }">
          <div class="mrauto">
            <div class="flex flex--align-vertical">
              <i :class="plan.icon"></i>
              <h2 class="text-color-white text-medium text-size-24 pr10 pl7 mb0">{{plan.name}}</h2>
            </div>
            <p class="text-white-08 text-regular text-size-16">{{plan.description}}</p>
          </div>
          <div class="flex flex--column flex--align-bottom">
            <h2 class="text-color-white text-medium text-size-24 mb0">$
              <template v-if="customerPaymentPlanPeriod === 'YEARLY'">{{filterPrice(plan.pricePerYear)}}</template>  
              <template v-if="customerPaymentPlanPeriod === 'MONTHLY'">{{filterPrice(plan.pricePerMonth)}}</template>  
            </h2>
            <p class="text-white-50 text-size-14"  v-if="customerPaymentPlanPeriod === 'YEARLY'">per month/billed yearly</p>
            <p class="text-white-50 text-size-14"  v-if="customerPaymentPlanPeriod === 'MONTHLY'">per month</p>
          </div>
          <div class="flex flex--align-vertical w100">
            <span
              v-for="(badge, index) in plan.badges" :key="badge.id"
              class="text-white-50 text-size-14 badge mb0" :class="{'mr2': index !== plan.badges.length - 1}"> 
              {{badge}}
            </span>
            <button class="btn mlauto" @click="onSelectedPlan(plan)">select</button>
          </div>
        </div>
        <div class="flex flex-nowrap flex--justify-space-between">
          <button @click="paymentSteps = 1" class="btn--dark-violet text-size-14 text-uppercase text-bold text-space-05 w-50 mr10">back</button>
        </div>
      </template>
      <!-- select new plan END -->

      <!-- change current plan -->
      <template v-else>
        <h2 class="text-color-white text-medium text-size-20 text-center text-uppercase text-space-05 pt20">{{filterPlanName(currentPlan)}}</h2>
        <button 
          v-if="currentPlan !== 'PAY_AS_YOU_GO'" 
          class="btn btn--green text-size-14 text-uppercase text-bold w-100 mb10" type="button" @click="redirectToPlatform()">
          change billing</button>
        <button v-else 
          class="btn btn--green text-size-14 text-uppercase text-bold w-100 mb10" type="button" @click="cancelSubscription()">
          cancel plan</button>
      </template>
      <!-- change current plan END -->
    </section>
    
    <!-- step 2 -->

    <!-- step3 -->
    <section v-show="paymentSteps === 3">
      <h2 class="text-color-white text-medium text-size-24 text-center pb30 mb0">Payment order</h2>
      <div class="flex flex--column flex--align-vertical">
        <div class="card p30 mb30">
          <i class="icon icon--qrcode"></i>
        </div>
        <button @click="paymentSteps = 1" class="btn--dark-violet text-size-14 text-uppercase w50">back</button>
      </div>
    </section>
    <!-- step3 -->
  </div>
</template>


<script>
import AppLoader from 'components/common/Loader'
import Countries from 'modules/CountryList.json'
import { mapActions } from 'vuex'
import { apiUpdateProjectData } from '@/api/projects.api'
import { apiPaymentExecute } from '@/api/project.api'
import { apiGetPaymentClientToken, apiGetStripePlatformRedirect, apiCreateStripeCustomer, apiCancelSubscription } from '@/api/stripe.api'
import { errorMessage } from 'modules/Error'

export default {
  components: {
    'app-loader': AppLoader,
    Countries
  },

  props: {
    args: {
      type: Object,
      required: false,
      default: () => {
        return {}
      }
    }
  },

  data () {
    return {
      // paymentSteps: 0, TODO temp disabled crypto
      paymentSteps: 1,
      userInformation: {
        customerFirstName: null,
        customerLastName: null,
        customerCompanyName: null,
        customerAddress: null,
        customerPost: null,
        customerPostCode: null,
        customerCountry: null,
        customerType: 'COMPANY',
        customerPaymentPlan: null
      },
      customerPaymentPlanPeriod: 'YEARLY', // TODO check this data property name
      clientToken: null,
      stripeManageSubscriptionRedirectUrl: "https://billing.stripe.com/session/_IMfVxZKe2YG47NlbG9NwFdNcFKU3zq3",
      countries: null,
      country: null,
      // paymentFailed: false,
      currentPlan: 'none',
      selectedPlan: 'none',
      planList: [
        {
          name: 'Diamond',
          description: 'Full-stack enterprise design',
          valueMonth: 'DIAMOND_MONTHLY',
          valueYear: 'DIAMOND_YEARLY',
          icon: 'icon-diamond',
          badges: ['240hrs', 'Performance design', 'Blockchain games', '+18'],
          pricePerMonth: 15995,
          pricePerYear: 13250
        },
        {
          name: 'Premium',
          description: 'Self-managed design team',
          valueMonth: 'PREMIUM_MONTHLY',
          valueYear: 'PREMIUM_YEARLY',
          icon: 'icon-cup',
          badges: ['120hrs', 'NFT art', 'Brand design', 'Art direction', '+16'],
          pricePerMonth: 7995,
          pricePerYear: 6650
        },
        {
          name: 'Pro',
          description: 'Industry-grade design quality',
          valueMonth: 'PRO_MONTHLY',
          valueYear: 'PRO_YEARLY',
          icon: 'icon-ship',
          badges: ['60hrs', 'Blockchain design', '3d', 'Project managment', '+13'],
          pricePerMonth: 3995,
          pricePerYear: 3350
        }
      ],
      legacyPlans: [
        {
          name: 'Premium (legacy)',
          value: 'PREMIUM',
          pricePerMonth: 6000
        },
        {
          name: 'Pro (legacy)',
          value: 'PRO_PLUS',
          pricePerMonth: 2995
        },
        {
          name: 'Essential (legacy)',
          value: 'ESSENTIAL_PLUS',
          pricePerMonth: 1995
        },
        {
          name: 'Flexible (legacy)',
          value: 'PAY_AS_YOU_GO',
          pricePerMonth: null,
          pricePerHour: 80
        }        
      ]
    } 
  },

  created () {
    this.init()
  },

  methods: {
    ...mapActions([
      'updateProjectProperties'
    ]),

    init () {
      this.userInformation = Object.assign(this.userInformation, this.args)

      this.countries = _.orderBy(Countries, 'countryName', 'asc')
      if (this.userInformation.customerCountry) {
        this.country = _.find(this.countries, country => {
          return country.countryName === this.userInformation.customerCountry
        })
      }
      this.getPaymentClientToken()
      this.setCurrentPlan()
      if (this.userInformation.customerPaymentPlan) {
        this.getStripePlatformRedirect()
      }
    },

    setCurrentPlan () {
      return this.userInformation.customerPaymentPlan
        ? (this.currentPlan = this.userInformation.customerPaymentPlan)
        : (this.currentPlan = 'none')
    },

    onCountrySelect () {
      this.userInformation.customerCountry = this.country.countryName
    },

    onSelectedPlan (plan) {
      this.customerPaymentPlanPeriod == 'YEARLY'
        ? (this.selectedPlan = plan.valueYear)
        : (this.selectedPlan = plan.valueMonth)

      return this.onPaymentExecute(this.selectedPlan)
    },

    async onPaymentInformationUpdate () {
      const isValid = await this.$validator.validateAll()
      if (!isValid) return false

      const param = {...this.userInformation}
      param.projectId = this.userInformation.id

      const [err, data] = await apiUpdateProjectData(param)
      if (err) return errorMessage(err, 'Enable to update user information')
      this.updateProjectProperties(data)
      
      return this.createStripeCustomer()
    },  

    async createStripeCustomer () {
      this.$refs.loader.onShow()

      const [err] = await apiCreateStripeCustomer(this.args.id)
      this.$refs.loader.onClose()
      if (err) return errorMessage(err, 'Unable to create Stripe Customer. Try again later!')

      return (this.paymentSteps = 2)
    }, 

    async getPaymentClientToken () {
      const [err, data] = await apiGetPaymentClientToken(this.args.id)
      if (err) return errorMessage(err, 'Unable to get client token. Try again later!')

      return (this.clientToken = data.token)
    },

    async getStripePlatformRedirect () {
      const [err, data] = await apiGetStripePlatformRedirect(this.args.id)
      if (err) return errorMessage(err, 'Unable to get client token. Try again later!')

      return (this.stripeManageSubscriptionRedirectUrl = data.url)
    },

    // TODO add redirectToPlatform to control (button)
    redirectToPlatform () {
      this.getStripePlatformRedirect()
      window.location = this.stripeManageSubscriptionRedirectUrl
    },

    async onPaymentExecute (paymentPlan) { // TODO test this 
      this.$refs.loader.onShow()
      const [err, data] = await apiPaymentExecute(this.args.id, paymentPlan)
      this.$refs.loader.onClose()
      if (err) return errorMessage(err, 'Unable to create an subscription!')

      if (!data.success) return this.$bus.$emit('toastError', 'Failed to complete payment. Please try again.')

      if (data.redirectToStripe) {
        const stripe = Stripe(this.clientToken);
        return stripe.redirectToCheckout({
              // Make the id field from the Checkout Session creation API response
              // available to this file, so you can provide it as parameter here
              // instead of the {{CHECKOUT_SESSION_ID}} placeholder.
          sessionId: data.sessionId
        }).then(result => {
              // If `redirectToCheckout` fails due to a browser or network
              // error, display the localized error message to your customer
              // using `result.error.message`.
        });
      } 
      this.$bus.$emit('modalClose')
      return this.$bus.$emit('toastSuccess', 'Your "Flexible plan" subscription successfully saved!')
    },

    async cancelSubscription () {
      this.$refs.loader.onShow()
      const [err, data] = await apiCancelSubscription(id)
      this.$refs.loader.onClose()
      if (err) return errorMessage(err, 'Failed to cancel subscription. Please contact your project manager.')

      if (!data.success) {
        return this.$bus.$emit('toastError', 'Failed to cancel subscription. Please contact your project manager.')
      } 

      this.$refs.loader.onClose()
      this.$bus.$emit('modalClose')
      window.location.reload()
      return this.$bus.$emit('toastSuccess', 'Your subscription successfully canceled!')
    },

    filterPrice (price) {
      const length = price.toString().length
      return price.toString().length > 1
          ? `${price.toString().slice(0, length - 3)},${price.toString().slice(length - 3, length)}`
          : `${price}` 
    },

    filterPlanName (planName) {
      let plan = this.planList.filter(el => el.valueMonth === planName)[0]
      let period = 'monthly'
      if (plan === undefined) {
        plan = this.planList.filter(el => el.valueYear === planName)[0]
        period = 'yearly'
      }
      if (plan === undefined) {
        plan = this.legacyPlans.filter(el => el.value === planName)[0]
        period = ''
      }
      return `${plan.name} ${period}`
    }
  }
}
</script>


// WEBPACK FOOTER //
// ProjectTopUpModal.vue?6f2600cc